import { useEffect, useState } from 'react';

import { createLandingUrl } from '@webapp/common/lib/utils';

import { JsonLd } from '@webapp/landing/src/components/json-ld';

import { getPlans } from './items';
import { Plan } from './plan';

import css from './pricing-plans.css';

export const PricingPlans: FC = () => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const plans = getPlans(mounted);

    return (
        <div className={css.pricingPlans}>
            <JsonLd
                data={{
                    '@context': 'https://schema.org',
                    '@type': 'SoftwareApplication',
                    name: 'Testograf',
                    url: createLandingUrl(''),
                    applicationCategory: 'BusinessApplication',
                    operatingSystem: 'Web',
                    description:
                        'Конструктор онлайн-опросов и тестов: логика ветвления, встроенная аналитика, API-интеграции.',
                    offers: plans.map((plan) => ({
                        '@type': 'Offer',
                        // header of the PRO+ plan is JSX, see items.tsx
                        name: typeof plan.header === 'string' ? plan.header : 'Годовая лицензия PRO+',
                        price: String(plan.price),
                        priceCurrency: 'RUB',
                        url: createLandingUrl('/ru/pricing-plans'),
                    })),
                }}
            />
            <h1>Тарифы</h1>
            <div className={css.plans}>
                {plans.map(({ header, hint, items, price }) => (
                    <Plan header={header} hint={hint} items={items} key={price} price={price} />
                ))}
            </div>
        </div>
    );
};
